import i18next from "i18next";
import esTranslation from "./locales/es-translation.js";
import caTranslation from "./locales/ca-translation.js";
import $ from "jquery";

export const API_BASE = "https://app.alcoi.org/iot/api/v1";

function init() {
  i18next.init({
    lng: $("html").attr("lang"),
    resources: {
      es: { translation: esTranslation },
      ca: { translation: caTranslation },
    },
  });
}

/**
 * Filtra caracteres expeciales en el entityId
 */
export function filtraEntityId(str) {
  return str.replace(/-|:|\./g, "_");
}

/**
 * Convierte a objeto Date los strings de fecha de la API
 */
export function parseDateApi(strDate) {
  let date = null;
  if (strDate) {
    date = new Date(strDate.replace(" ", "T") + "Z");
  }
  return date;
}

export { i18next };

init();
